import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";

const AuthDialog = ({ open, onClose, onLoginSuccess }) => {
  const { login, signup } = useAuth(); // Use signup from AuthContext

  const [tab, setTab] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleAuth = async () => {
    try {
      if (tab === 0) {
        // Login
        const success = await login({ email, password });
        if (success) {
          onClose();
          setEmail("");
          setPassword("");
        }
      } else {
        // Sign Up
        const success = await signup({ email, password }); // Use signup function
        if (success) {
          alert("Registration successful! Please log in.");
          setTab(0); // Switch to login tab
        }
      }
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    handleAuth();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{tab === 0 ? "Login" : "Sign Up"}</DialogTitle>
      <DialogContent>
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          sx={{ mb: 2 }}
          centered
        >
          <Tab label="Login" />
          <Tab label="Sign Up" />
        </Tabs>
        <Box
          component="form"
          autoComplete="on"
          id="authForm"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="Email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            name="email"
            autoComplete="username"
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            name="password"
            autoComplete="current-password"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          type="submit"
          form="authForm"
          variant="contained"
          color="primary"
        >
          {tab === 0 ? "Login" : "Sign Up"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthDialog;